import { connect } from 'react-redux';
import { LicenseSearchBegin } from '../../store/actions/license.actions';
import { getLicenseListSearched, getPersonListSearched } from '../../store/selectors/license.selectors';
import { getSiteTitle, getSiteFeaturesList } from '../../store/selectors/site.selectors';
import App from './App';

const mapStateToProps = (state: any) => {
    const licenseListSearched = getLicenseListSearched(state);
    const siteTitle = getSiteTitle(state);
    const featureFlags = getSiteFeaturesList(state);
    const personListSearched = getPersonListSearched(state);
    return {
        licenseListSearched,
        licenseListSearchedCount: licenseListSearched.length,
        siteTitle,
        featureFlags,
        personListSearched,
    };
};

const mapDispatchToProps = {
    searchLicense: LicenseSearchBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
